import React, {useContext, useEffect, useState} from "react";
import {
    Card,
    CardActions,
    CardContent,
    Checkbox,
    FormControlLabel,
    FormGroup,
    Snackbar,
    TextField,
    Typography
} from "@mui/material";
import Grid from "@mui/material/Grid";
import LoadingButton from '@mui/lab/LoadingButton';
import {LanguageContext} from "../context/LanguageContext";
import ReactRecaptcha3 from 'react-google-recaptcha3';
import axios from "axios";
import {env} from "../properties";
import {Alert} from "@mui/material";
import {UmamiContext} from "../context/UmamiContext";

const snackbarInitialState = {
    open: false,
    message: "",
    severity: "success"
};

const useValidator = false;

const Rating = () => {

    const langContext = useContext(LanguageContext);

    const [loading, setLoading] = useState(false);
    const [ratingDesc, setRatingDesc] = useState("");
    const [ratingStatement, setratingStatement] = useState(true);

    const [rateErr, setRateErr] = useState("");
    const [snackbarState, setSnackbarState] = useState(snackbarInitialState);

    const umamiContext = useContext(UmamiContext);

    const searchParams = new URLSearchParams(document.location.search);
    let urlkey = null;
    if(searchParams.get("key") != null)
    {
        urlkey = {
            survery: searchParams.get("key").substring(0,32),
            rating: searchParams.get("key").substring(33)
        }
    }else
    {
        urlkey = {
            survery: document.location.search.substring(1,33),
            rating: document.location.search.substring(34)
        }
    }

    useEffect(() => {
        ReactRecaptcha3.init("6LesR5cpAAAAAOvYLPIB0n3ykl8tGOnfavfKf_Yo");
    }, [])

    const validateFields = () => {
        if (!useValidator) {
            return false;
        }
        let hasError = false;
        return hasError;
    }

    const clear = () => {
        setRatingDesc("");
        setratingStatement(true);
    }


    const submit = () => {
        if (validateFields()) {
            return;
        }
        setLoading(true);
        ReactRecaptcha3
            .getToken()
            .then(
                (resp) => {
                    let requestData = {
                        token: resp,
                        survery: urlkey.survery,
                        rating: urlkey.rating,
                        ratingDesc: ratingDesc,
                        ratingStatement: ratingStatement

                    };
                    axios.post(`${env.apiRoot}/survery`, requestData).then(response => {
                        clear();
                        setSnackbarState({open: true, message: langContext.dictionary.success, severity: "success"});
                    }).catch(error => {
                        console.error(error);
                        setSnackbarState({
                            open: true,
                            message: langContext.dictionary.errorDuringRegistration + " " + error.message,
                            severity: "error"
                        });
                    }).finally(() => {
                        setLoading(false);
                    })
                }
            ).catch((error) => {
            console.error(error);
            setSnackbarState({
                open: true,
                message: langContext.dictionary.errorDuringRegistration,
                severity: "error"
            });
            setLoading(false);
        });
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarState(snackbarInitialState);
    };

    return (
        <>
        { snackbarState.open === false &&
            <Card>
                <CardContent>
                    <>
                        <Typography gutterBottom variant="h5" component="div">
                            {langContext.dictionary.title}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {langContext.dictionary.desc + urlkey.rating + langContext.dictionary.desc2}
                        </Typography>
                        { urlkey.rating < 7 &&
                        <Grid container spacing={2} sx={{paddingTop: 3}}>
                            <Grid item xs={12} md={12}>
                                <TextField
                                    id="outlined-basic" fullWidth label={langContext.dictionary.fields.rating}
                                    variant={"outlined"}
                                    onChange={evt => setRatingDesc(evt.target.value)}
                                    error={rateErr.length > 0}
                                    helperText={rateErr}
                                    value={ratingDesc}
                                    inputProps={{maxLength: 255}}
                                    multiline
                                    rows={4}
                                    maxRows={6}
                                    placeholder={langContext.dictionary.fields.ratingPlace}
                                    display
                                />
                            </Grid>
                        </Grid>
                    }
                    <Grid>
                        <FormGroup >
                            <FormControlLabel
                                variant={"outlined"}
                                color="text.secondary"
                                control={
                                <Checkbox
                                    defaultChecked
                                    size="small"
                                    onChange={evt => setratingStatement(evt.target.checked)}
                                />
                            }
                                label={langContext.dictionary.fields.ratingCheck} />
                        </FormGroup>
                    </Grid>
                    </>
                </CardContent>
                <CardActions>
                    <LoadingButton loading={loading}
                                   variant="contained"
                                   color="secondary"
                                   onClick={() => {
                                       submit();
                                   }}
                                   sx={{
                                       marginLeft: 1,
                                       marginBottom: 1
                                   }}
                    >{langContext.dictionary.send}</LoadingButton>
                </CardActions>
            </Card>
        }
        { snackbarState.open &&
            <Card>
                <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                        {langContext.dictionary.dearCustomer}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {((urlkey.rating < 7)? langContext.dictionary.sentMessage: langContext.dictionary.sentMessageGood)}
                    </Typography>
                </CardContent>
            </Card>
        }

        </>
    );

};

export default Rating;
